import { gql } from '@apollo/client';

export const GET_WIDGET_ACTIVITY_WAITLISTINGS = gql`
  query GetWidgetActivityWaitlistings(
    $programIds: [String!]
    $activityIds: [String!]
    $range: String
    $widgetType: String
  ) {
    vm {
      activityWaitlistings(programIds: $programIds, activityIds: $activityIds, range: $range, widgetType: $widgetType) {
        activityWaitlistingId
        dateAdded
        dateRemoved
        activity {
          activityId
          name
          isActive
          priority
          program {
            name
            programId
            dateSuspended
            dateDeleted
          }
        }
        volunteer {
          volunteerId
          profile {
            profileId
            userId
            firstName
            lastName
            avatarUrl
            preferredName
          }
          dateDeactivated
          flagging {
            dateFlagged
          }
        }
      }
    }
  }
`;
